import TimeWheelInline from "@/components/v2/time-wheel/time-wheel-inline";
import { getReadableTimeDiff } from "@/utils/dates";
import { Calendar, Card, DateField, DatePicker, Label } from "@heroui/react";
import { parseDate } from "@internationalized/date";
import { CalendarIcon, Clock } from "lucide-react";
import { useState } from "react";

const MeetingDetailsDateComp = ({ value, onChange }) => {
  const [date, setDate] = useState(() => parseDate(value.meeting_date));
  const [startTime, setStartTime] = useState(value.start_time?.real || value.start_time?.set || "");
  const [endTime, setEndTime] = useState(value.end_time?.real || value.end_time?.set || "");

  const inputClass =
    "border h-[36px] rounded-xl shadow-none border-px border-[#4E4E9826] dark:border-[#ECECEC26] dark:bg-[#2020200D] bg-[#4E4E980D]";
  const labelClass = "flex items-center gap-1 dark:text-[#AFAFAF] text-xs";

  function handleDateChange(dateValue) {
    setDate(dateValue);

    onChange({ meeting_date: dateValue.toString() });
  }

  function handleStartTimeChange(time) {
    setStartTime(time);
    onChange({ start_time: { set: time, real: time } });
  }

  function handleEndTimeChange(time) {
    setEndTime(time);
    onChange({ end_time: { set: time, real: time } });
  }

  return (
    <Card className="bg-[#FFFFFFAD] dark:bg-[#000000B2]">
      <Card.Content className="gap-7">
        <div className="flex flex-col gap-1.5">
          <Label className={"flex items-center gap-1"}>
            <CalendarIcon size={12} className="" /> Event Date
          </Label>
          <DatePicker name="date" value={date} onChange={handleDateChange} className={"shadow-none"}>
            <DateField.Group fullWidth className={inputClass}>
              <DateField.Input>{(segment) => <DateField.Segment segment={segment} />}</DateField.Input>
              <DateField.Suffix>
                  <DatePicker.Trigger className={"shadow-none border border-separator dark:border-[#ECECEC26] dark:bg-[#2020200D]"}>
                  <DatePicker.TriggerIndicator />
                </DatePicker.Trigger>
              </DateField.Suffix>
            </DateField.Group>
            <DatePicker.Popover>
              <Calendar aria-label="Event date">
                <Calendar.Header>
                  <Calendar.YearPickerTrigger>
                    <Calendar.YearPickerTriggerHeading />
                    <Calendar.YearPickerTriggerIndicator />
                  </Calendar.YearPickerTrigger>
                  <Calendar.NavButton slot="previous" />
                  <Calendar.NavButton slot="next" />
                </Calendar.Header>
                <Calendar.Grid>
                  <Calendar.GridHeader>{(day) => <Calendar.HeaderCell>{day}</Calendar.HeaderCell>}</Calendar.GridHeader>
                  <Calendar.GridBody>{(date) => <Calendar.Cell date={date} />}</Calendar.GridBody>
                </Calendar.Grid>
                <Calendar.YearPickerGrid>
                  <Calendar.YearPickerGridBody>
                    {({ year }) => <Calendar.YearPickerCell year={year} />}
                  </Calendar.YearPickerGridBody>
                </Calendar.YearPickerGrid>
              </Calendar>
            </DatePicker.Popover>
          </DatePicker>
        </div>

        <div className="flex flex-col gap-1.5">
          <Label className={labelClass}>
            {" "}
            <Clock size={16} /> <span>Duration: {getReadableTimeDiff(startTime, endTime)}</span>
          </Label>

          <div className="flex items-center gap-2">
            <TimeWheelInline value={startTime} onSelect={handleStartTimeChange} minuteStep={15} columnClassName="bg-[#4E4E980D]! border-[#4E4E9826]! dark:border-[#ECECEC26] dark:bg-[#20202012] w-[54px]!"/>
            <span className="text-muted">-</span>
            <TimeWheelInline value={endTime} onSelect={handleEndTimeChange} minuteStep={15} columnClassName="bg-[#4E4E980D]! border-[#4E4E9826]! dark:border-[#ECECEC26] dark:bg-[#20202012] w-[54px]!"/>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default MeetingDetailsDateComp;